export default __webpack_public_path__ + "static/char-52-afa12144f0a5b3c6650b1be6a87a9658.gif";